import * as React from 'react';

interface IProps {
    onClick: () => void;
    label: string;
};

const SecondaryButton = (props: IProps) => (<button
    className="absolute pin-t pin-l my-4 p-2 px-8 rounded-full text-grey-darkest bg-grey-light font-montserrat"
    onClick={props.onClick}
  >
    {props.label}
  </button>);


export default SecondaryButton;



// WEBPACK FOOTER //
// ./src/components/SecondaryButton.tsx